export enum EReservationTagsVariants {
    ORIGINAL = 'ORIGINAL',
    CAR_LISTING_AND_PROFILE = 'CAR_LISTING_AND_PROFILE',
    CAR_PROFILE_ONLY = 'CAR_PROFILE_ONLY',
}
